import {CustomerAdvancedSearchResultResponseBody} from '@dms/api/customer';

import {Nullish} from 'shared/web';

import {getNaturalPersonFullName} from '../../../utils/getNaturalPersonFullName';

export const getAdvancedCustomerName = (
  customer: CustomerAdvancedSearchResultResponseBody | Nullish
) => {
  if (customer?.discriminator === 'BUSINESS') {
    return customer.tradeName;
  }

  return getNaturalPersonFullName(customer?.foundingPerson);
};
